import { LoanStatus } from '@willow/types-iso';

/*
    While any loan can be flagged,
    there are some states that we don't allow the lender to specify stop settings while flagging
*/
export const EDIT_STOP_SETTINGS_STATUS_PERMISSIONS: Record<LoanStatus, boolean> = {
  preActive: true,
  active: true,
  pendingTransfer: true,
  transferred: true,
  paidOff: true,
  liquidated: true,
  reo: true,
  pendingActivation: false,
  archived: false,
};
